import {
  BLACK_FRIDAY_PRO_PLAN,
  PRO_PLAN,
  BLACK_FRIDAY_PROMOTION_PLAN_COUNT,
  PROMOTION_PLAN_COUNT,
} from '../pages/PlansPage/constants';
import { Plan } from '../pages/PlansPage/types';

/**
 * Check if Black Friday promotion is still active
 * returns true if current time is before the target time
 */
export const isBlackFridayActive = (): boolean => {
  const now = new Date();
  const targetTime = new Date('2025-12-01T23:59:59-07:00');
  return now.getTime() < targetTime.getTime();
};

/**
 * Get plan detail based on promotion status
 * returns BLACK_FRIDAY_PRO_PLAN if promotion is active, otherwise PRO_PLAN
 */
export const getPlanDetail = (): Plan =>
  isBlackFridayActive() ? BLACK_FRIDAY_PRO_PLAN : PRO_PLAN;

/**
 * Get max plan count based on promotion status
 * returns BLACK_FRIDAY_PROMOTION_PLAN_COUNT if promotion is active, otherwise PROMOTION_PLAN_COUNT
 */
export const getMaxPlanCount = (): number =>
  isBlackFridayActive()
    ? BLACK_FRIDAY_PROMOTION_PLAN_COUNT
    : PROMOTION_PLAN_COUNT;
